import React from 'react';
import Button from 'aldoo-ra/Button';
import { Icons } from '../../components/Icon.jsx';
import ComponentsTab from './ComponentsTab.jsx';
import PrefabsTab from './PrefabsTab.jsx';
import HierarchyPanel from '../../components/HierarchyPanel.jsx';

const LeftSidebar = ({ activeSidebarTab, onTabChange, controller }) => {
  const {
    prefabs,
    visiblePrefabs,
    selectedPrefabId,
    prefabSearchTerm,
    editingPrefabId,
    editingName,
    onPrefabSearchChange,
    onPrefabSelect,
    onPrefabDoubleClick,
    onPrefabRename,
    onPrefabDelete,
    onPrefabEditNameChange,
    onPrefabEditNameBlur,
    onPrefabEditNameKeyDown,
    onPrefabDragStart,
    onPrefabDragEnd,
    nodes,
    selectedNodeIds,
    onHierarchySelect,
    onHierarchyMove,
    onHierarchyUpdate,
    onContextMenuAction,
    onFocusItem,
    rootId,
    collapsedNodeIds,
    onToggleNodeExpansion
  } = controller;
  return (
    <div className="w-64 bg-admin_paper border-r border-admin_bordered flex flex-col z-10 shadow-lg">
      <div className="flex text-xs font-bold border-b border-admin_bordered bg-admin_canvas">
        <button
          className={`flex-1 py-3 transition-colors ${
            activeSidebarTab === 'hierarchy'
              ? 'text-blue-600 bg-white border-b-2 border-blue-500'
              : 'text-gray-500 hover:bg-admin_neutral_1/10'
          }`}
          onClick={() => onTabChange('hierarchy')}
        >
          HIERARCHY
        </button>
        <button
          className={`flex-1 py-3 transition-colors ${
            activeSidebarTab === 'components'
              ? 'text-blue-600 bg-white border-b-2 border-blue-500'
              : 'text-gray-500 hover:bg-admin_neutral_1/10'
          }`}
          onClick={() => onTabChange('components')}
        >
          COMPONENTS
        </button>
        <button
          className={`flex-1 py-3 transition-colors ${
            activeSidebarTab === 'prefabs'
              ? 'text-blue-600 bg-white border-b-2 border-blue-500'
              : 'text-gray-500 hover:bg-admin_neutral_1/10'
          }`}
          onClick={() => onTabChange('prefabs')}
        >
          PREFABS
        </button>
      </div>

      <div className="flex-1 overflow-y-auto relative bg-admin_paper">
        {activeSidebarTab === 'hierarchy' && (
          <HierarchyPanel
            nodes={nodes}
            selectedNodeIds={selectedNodeIds}
            onSelect={onHierarchySelect}
            onMove={onHierarchyMove}
            onUpdate={onHierarchyUpdate}
            onContextMenuAction={onContextMenuAction}
            onFocusItem={onFocusItem}
            rootId={rootId}
            collapsedNodeIds={collapsedNodeIds}
            onToggleNodeExpansion={onToggleNodeExpansion}
          />
        )}
        {activeSidebarTab === 'components' && <ComponentsTab />}
        {activeSidebarTab === 'prefabs' && (
          <PrefabsTab
            prefabs={visiblePrefabs}
            selectedPrefabId={selectedPrefabId}
            searchTerm={prefabSearchTerm}
            editingPrefabId={editingPrefabId}
            editingName={editingName}
            onSearchChange={onPrefabSearchChange}
            onPrefabSelect={onPrefabSelect}
            onPrefabDoubleClick={onPrefabDoubleClick}
            onPrefabRename={onPrefabRename}
            onPrefabDelete={onPrefabDelete}
            onEditNameChange={onPrefabEditNameChange}
            onEditNameBlur={onPrefabEditNameBlur}
            onEditNameKeyDown={onPrefabEditNameKeyDown}
            onPrefabDragStart={onPrefabDragStart}
            onPrefabDragEnd={onPrefabDragEnd}
          />
        )}
      </div>
    </div>
  );
};

export default LeftSidebar;
